import './styles.css';
import { mountApp } from './app';
import { clearActivityLog } from './lib/activity-log';
import { initTheme } from './lib/theme';
import { registerSW } from 'virtual:pwa-register';

initTheme();
clearActivityLog();
mountApp(document.getElementById('app')!);

registerSW({ immediate: true });
